import { useQuery } from "@tanstack/react-query";
import { FirestoreError } from "firebase/firestore";
import { QUERY_KEY } from "@/modules/projetos/components/projetos-table/ProjetosTable";
import { getProjetosItem } from "@/modules/projetos/firestore";

type TGetProjetoResponse = Awaited<ReturnType<typeof getProjetosItem>>;

/**
 * Get projeto from url params
 * @param empresaId - id da empresa
 * @param projetoId - id do projeto
 * @returns - projeto or null if not found
 */
function useGetProjetoItem(empresaId: TEmpresa["id"], projetoId: TProjeto["id"]) {
  return useQuery<TGetProjetoResponse, FirestoreError, TProjeto | null>({
    queryKey: [QUERY_KEY, empresaId, projetoId],
    queryFn() {
      return getProjetosItem(empresaId, projetoId);
    },
    select(dataResponse) {
      if (!dataResponse.exists()) {
        return null;
      }

      return dataResponse.data();
    }
  });
}

export default useGetProjetoItem;
